import React, { useState } from 'react';
import moment from 'moment';
import MsgItem from 'component/MsgItem';
import styles from './index.module.scss';
import { Meeting, MeetingState, OrderSignStatus, OrderState } from 'type/meeting';
import { formatRemind, formatMeetingType, formatTimeRange, parseHtml } from 'util/format';
import classnames from 'classnames';
import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { signRoom } from 'model/room';
import FridayTracker from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';
import IotModal from '../IotModal';
import { revokeMeeting, cancelMeeting, closeMeeting } from 'model/meeting';
import UnderApprovalTag from 'component/RoomTable/components/UnderApprovalTag';
import tracker from 'lib/tracker';

import { push } from 'connected-react-router';
import APP_ROUTE from 'constant/route';

interface IProps {
  info: Meeting;
  canEdit?: boolean;
  editClick?: () => void;
  showSign?: boolean;
  isApproval?: boolean;
  isCreator?: boolean;
  showAction?: boolean;
}

const meetingStateLabel: { [key: number]: string } = {
  [MeetingState.READY]: '待开始',
  [MeetingState.BEGIN]: '会议中',
  [MeetingState.DISBAND]: '已取消',
  [MeetingState.END]: '已结束',
  [MeetingState.SAVED]: '已归档'
};

const MeetingInfo: React.FunctionComponent<IProps> = ({
  info,
  canEdit = false,
  editClick,
  showSign = false,
  isApproval = false,
  isCreator,
  showAction = true
}) => {
  const { subject, beginTime, endTime, noticeLabels, address, scope, content, state, orderState, _id, iotMessage, meetingAuditRecordView, orderSignStatus } =
    info;
  const { reason, auditorList = [] } = meetingAuditRecordView || {};

  const result: number[] = [];
  const data: string[] = [];
  const [signStatus, setSignStatus] = useState(orderSignStatus == OrderSignStatus.FINISH_SIGN);
  if (noticeLabels && noticeLabels !== null && noticeLabels.length > 1) {
    // 做个排序
    // eslint-disable-next-line array-callback-return
    noticeLabels.map((item) => {
      result.push(Number(item.replace(/[^\d]/g, ' ')));
    });
    const resultArray = result.sort((a: number, b: number) => {
      return a - b;
    });

    // eslint-disable-next-line array-callback-return
    resultArray.map((item) => {
      // eslint-disable-next-line array-callback-return
      noticeLabels.map((k) => {
        if (item === 0 && k === 'on_time') {
          data[0] = k;
        } else if (item === 5 && k === 'before_5') {
          data.push(k);
        } else if (item === 10 && k === 'before_10') {
          data.push(k);
        } else if (item === 15 && k === 'before_15') {
          data.push(k);
        } else if (item === 20 && k === 'before_20') {
          data.push(k);
        } else if (item === 30 && k === 'before_30') {
          data.push(k);
        }
      });
    });
  }
  const begin = moment(beginTime);
  const now = moment();
  const before10Min = now.valueOf() > begin.subtract(10, 'm').valueOf();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();

  const detailData = [
    {
      title: '时间',
      iconType: 'iconhuiyi_shijian',
      detailText: formatTimeRange(beginTime, endTime)
    },
    {
      title: '提醒',
      iconType: 'iconhuiyi_tixing',
      detailText: (noticeLabels && noticeLabels.length > 1 ? data : noticeLabels)?.map((label) => formatRemind(label)).join('，')
    },
    {
      title: '地点',
      iconType: 'iconhuiyi_huiyishi',
      detailText: address
    },
    {
      title: '审批人',
      iconType: '',
      detailText:
        auditorList
          .map((val: any) => val.realName)
          .filter((val: string) => val)
          .join('、') || '-',
      hide: !meetingAuditRecordView || info._id
    },
    {
      title: '申请理由',
      iconType: '',
      detailText: reason || '-',
      hide: !meetingAuditRecordView || info._id
    },
    {
      title: '会议类型',
      iconType: 'iconhuiyi_huiyileixing',
      detailText: formatMeetingType(scope)
    },
    {
      title: '议程',
      iconType: 'iconhuiyi_yicheng',
      detailText: parseHtml(content)
    }
  ];

  const stateCls = classnames(styles.state, {
    [styles.ready]: state === MeetingState.READY,
    [styles.begin]: state === MeetingState.BEGIN,
    [styles.end]: state === MeetingState.END || state === MeetingState.SAVED
  });

  const signClick = () => {
    dispatch(signRoom(_id));
  };

  const canSign = (orderState === OrderState.BEFORE || !orderState) && state <= MeetingState.BEGIN;

  const signMsgColor = state === 0 || state === 1;
  const getIotMessage = () => {
    if (state === 0 || state === 1) {
      setIsModalVisible(true);
      setSignStatus(true);
      // dispatch(getMeetingIotDevices(_id));
    }
  };
  const closeIotMsg = () => {
    setIsModalVisible(false);
  };

  const _cancelMeeting = () => {
    tracker?.reporteSchOperation('取消会议预约');
    dispatch(cancelMeeting(info));
    setTimeout(() => {
      dispatch(push(APP_ROUTE.SCHEDULE));
    }, 1000);
  };
  const _closeMeeting = () => {
    dispatch(closeMeeting(info));
    // setTimeout(() => {
    //   dispatch(push(APP_ROUTE.SCHEDULE));
    // }, 1000);
  };

  const _revokeMeeting = () => {
    if (!info.meetingAuditRecordView?.id) return;
    dispatch(revokeMeeting(info.meetingAuditRecordView?.id));
    setTimeout(() => {
      dispatch(push(APP_ROUTE.SCHEDULE));
    }, 1000);
  };

  const isShowCancelMeeting = () => {
    if (isApproval) {
      return false;
    }
    return isCreator && state === MeetingState.READY;
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>
          <div className={styles.subject}>{subject}</div>
          {isApproval ? <UnderApprovalTag className={styles.under_approval} /> : <div className={stateCls}>{meetingStateLabel[state]}</div>}
        </div>
        {/* 操作按钮 */}
        {showAction && (
          <div className={styles.mettingInfoButtons}>
            {canEdit && canSign && (
              <FridayTracker {...FRIDAYAGENT_EVENTS.WEB_TEAMS_CLICK_DETAIL_MODIFY_INFO}>
                <Button className={styles.editButton} type="default" onClick={editClick}>
                  编辑
                </Button>
              </FridayTracker>
            )}
            {isApproval && (
              <FridayTracker {...FRIDAYAGENT_EVENTS.WEB_TEAMS_CLICK_DETAIL_CANCEL_MEETING}>
                <Button
                  className={styles.cancelButton}
                  onClick={() => {
                    Modal.confirm({
                      title: '撤销申请',
                      icon: '',
                      content: '撤销申请后无法恢复，确定要撤销吗？',
                      okText: '确定',
                      cancelText: '取消',
                      onOk: _revokeMeeting,
                      centered: true,
                      autoFocusButton: null
                    });
                  }}
                >
                  撤销申请
                </Button>
              </FridayTracker>
            )}
            {isShowCancelMeeting() && (
              <Button
                className={styles.cancelButton}
                onClick={() => {
                  Modal.confirm({
                    title: '取消预约',
                    icon: '',
                    content: '取消后将通知各个参会人，且无法恢复，确定要取消吗？',
                    okText: '取消预约',
                    cancelText: '保留会议',
                    onOk: _cancelMeeting,
                    onCancel: () => {
                      console.log('-=--=>', '保留会议');
                      tracker?.reporteSchOperation('保留会议');
                    },
                    okType: 'danger',
                    centered: true,
                    autoFocusButton: null
                  });
                }}
              >
                取消预约
              </Button>
            )}
            {isCreator && state === MeetingState.BEGIN && (
              <FridayTracker {...FRIDAYAGENT_EVENTS.WEB_TEAMS_CLICK_DETAIL_END_MEETING}>
                <Button
                  className={styles.frontOverButton}
                  onClick={() => {
                    Modal.confirm({
                      title: '提前结束',
                      icon: '',
                      content: '确定要提前结束会议吗？',
                      okText: '提前结束',
                      cancelText: '取消',
                      onOk: _closeMeeting,
                      onCancel: () => {
                        console.log('-=--=>', '提前结束');
                        tracker?.reporteSchOperation('取消提前结束');
                      },
                      centered: true,
                      className: styles.modal,
                      autoFocusButton: null
                    });
                  }}
                >
                  提前结束
                </Button>
              </FridayTracker>
            )}
            {showSign && before10Min && canSign && (
              <div className={styles.sign} onClick={getIotMessage}>
                {
                  <FridayTracker {...FRIDAYAGENT_EVENTS.WEB_TEAMS_CLICK_DETAIL_SIGN}>
                    <Button type="primary" onClick={signClick}>
                      会议室签到
                    </Button>
                  </FridayTracker>
                }
              </div>
            )}
          </div>
        )}
      </div>
      {detailData.map((detail) =>
        detail.detailText && !detail.hide ? (
          <MsgItem
            title={detail.title}
            titleClass={styles.titleClass}
            iconType={detail.iconType}
            iconSize={24}
            customerClass={styles.item}
            childrenClass={styles.children}
            key={detail.title}
          >
            <div className={styles.meetingMsg}>
              <div className={styles.detailText}>
                {detail.detailText}
                {detail.iconType === 'iconhuiyi_huiyishi' && showSign && before10Min && (
                  <div className={styles.sign} onClick={getIotMessage}>
                    {canSign ? null : (
                      <div className={signMsgColor ? styles.signTextColor : styles.signText}>{signStatus ? '会议室已签到' : '会议室未签到'}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </MsgItem>
        ) : null
      )}
      {signMsgColor && <IotModal show={isModalVisible} onClose={closeIotMsg} iotMessage={iotMessage} />}
    </div>
  );
};

export default MeetingInfo;
